/** Dashboard “Graph” picker — ids + default labels (i18n via labelKey). */

export const DASHBOARD_GRAPH_OPTIONS = [
  { id: "sale_overview", labelKey: "graphSaleOverview", defaultLabel: "Sale overview" },
  { id: "total_sale", labelKey: "graphTotalSale", defaultLabel: "Total sale" },
  { id: "top_product", labelKey: "graphTopProduct", defaultLabel: "Top product" },
  { id: "top_customer", labelKey: "graphTopCustomer", defaultLabel: "Top customer" },
  { id: "customer_trend", labelKey: "graphCustomerTrend", defaultLabel: "Customer trend" },
  { id: "item_collection_segment", labelKey: "graphItemCollectionSegment", defaultLabel: "Item/Collection segment" },
  { id: "payment_method", labelKey: "graphPaymentMethod", defaultLabel: "Payment method" },
  { id: "saleperson_performance", labelKey: "graphSalepersonPerformance", defaultLabel: "Saleperson performance" },
  { id: "sale_by_customer_category", labelKey: "graphSaleByCustomerCategory", defaultLabel: "Sale by customer category" },
  { id: "age_and_gender", labelKey: "graphAgeAndGender", defaultLabel: "Age and gender" },
  { id: "customer_group", labelKey: "graphCustomerGroup", defaultLabel: "Customer group" },
  { id: "custom_order", labelKey: "graphCustomOrder", defaultLabel: "Custom order" },
  { id: "repair_order", labelKey: "graphRepairOrder", defaultLabel: "Repair order" },
  { id: "refund", labelKey: "graphRefund", defaultLabel: "Refund" },
  { id: "exchange", labelKey: "graphExchange", defaultLabel: "Exchange" },
  { id: "cash_register", labelKey: "graphCashRegister", defaultLabel: "Cash register" },
  { id: "credit_note", labelKey: "graphCreditNote", defaultLabel: "Credit note" },
  { id: "debit_note", labelKey: "graphDebitNote", defaultLabel: "Debit note" },
  { id: "deposit", labelKey: "graphDeposit", defaultLabel: "Deposit" },
  { id: "reserve", labelKey: "graphReserve", defaultLabel: "Reserve" },
  { id: "wishlist", labelKey: "graphWishlist", defaultLabel: "Wishlist" },
];

export const GRAPH_COL_COUNT = 5;

/** Chunk options into columns top-to-bottom per column (Figma: col1 = first 5, …). */
export function getGraphOptionColumns(options = DASHBOARD_GRAPH_OPTIONS, colCount = GRAPH_COL_COUNT) {
  const columns = Array.from({ length: colCount }, () => []);
  if (options.length === 0) return columns;
  const perCol = Math.ceil(options.length / colCount);
  options.forEach((opt, i) => {
    const col = Math.min(Math.floor(i / perCol), colCount - 1);
    columns[col].push(opt);
  });
  return columns;
}
